/** Prefer a single display name; merge legacy companyName when present. */
export const listingDisplayName = (listing: {
  name?: string;
  companyName?: string;
}): string | undefined => {
  const name = listing.name?.trim();
  const companyName = listing.companyName?.trim();

  if (name && companyName && name !== companyName) {
    return `${name} · ${companyName}`;
  }
  return name || companyName || undefined;
};
